export const FILE_NAME = 'file_name'
export const FILE = 'file'

export const initialDocumentFileValues = {
  [FILE]: ''
}
